<template>
    <div class="flex flex-col gap-7">
        <timeline
            :order="[ETimelineOrder.IS_PINNED, ETimelineOrder.PUBLISHED_AT_DESC]"
        />
    </div>
</template>

<script setup lang="ts">
    import Timeline from '~/components/timeline/TheTimeline.vue';
    import { ETimelineOrder } from '~/types/enums';
</script>
